class VerticalNewsSlider {
  
  constructor(showTypeSkipIds, skipSeconds) {
    this.activeSlider = null;
    this.switchButtons = [];
    this.sliderContainer = document.querySelector('.vertical-news-slider-container');
    this.sliderSwitcher = this.sliderContainer.querySelector('.slider-switcher');
    this.sliders = this.sliderContainer.querySelectorAll('.vertical-news-slider');
    this.swiper = null;

    this.bgVideoLoader = null;
    this.bgPlayerContainer = null;
    this.bgPlayerJw = null;
    this.currentVideoPlay = null;
    this.showTypeSkipIds = showTypeSkipIds;
    this.skipSeconds = skipSeconds;
    this.currentSeek = 0; // Default = 0
    this.progressBar = null;
    this.progressBarContainer = this.createProgressBar();
  }
  
  init() {
    
    this.sliders.forEach((slider, index) => {
      slider.index = index;
      
      // Create slider switch button
      var button = document.createElement('button');
      button.classList.add('btn', 'btn-sm', 'btn-pill', 'mx-1', slider.dataset.color);
      button.dataset.sliderId = slider.dataset.id;

      if (slider.dataset.customHtmlTitle) {
        button.innerHTML = slider.dataset.customHtmlTitle;
      } else {
        button.textContent = slider.dataset.sliderName;
      }
      
      // Add event listener to switcher button
      button.addEventListener('click', (e) => {
        let sliderId = e.target.dataset.sliderId;

        if (!sliderId) {
          let parent = e.target.closest('[data-slider-id]');
          sliderId = parent ? parent.dataset.sliderId : null;
        }

        if ( sliderId == newsSlider.activeSlider.dataset.id ) {
          reloadSlider(sliderId);
        }

        if (sliderId) this.switchSlider(sliderId);

      });
      
      this.switchButtons.push(button);
      
      // Create style for active the button
      var style = document.createElement('style');
      style.innerHTML = `
        .vertical-news-slider-container .slider-switcher .btn.active.${slider.dataset.color} {
          color: #fff;
          background-color: var(--${slider.dataset.color});
          border-color: var(--${slider.dataset.color});
        }`;
      this.switchButtons.push(style);
      
    });
    
    this.switchButtons.forEach( button => {
      this.sliderSwitcher.appendChild(button);
    })
    
    this.switchSlider(this.parseSliderId());
    
  }

  createProgressBar() {

    /* Create DOM instance:
    <div class="video-progress-mask">
      <div class="video-progress">
        <div class="video-progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
    */

    // Create the outer container
    const mask = document.createElement('div');
    mask.className = 'video-progress-mask';

    // Create the progress wrapper
    const progress = document.createElement('div');
    progress.className = 'video-progress';

    // Create the progress bar
    this.progressBar = document.createElement('div');
    this.progressBar.className = 'video-progress-bar';
    this.progressBar.setAttribute('role', 'progressBar');
    this.progressBar.style.width = '0%';
    this.progressBar.setAttribute('aria-valuenow', '0');
    this.progressBar.setAttribute('aria-valuemin', '0');
    this.progressBar.setAttribute('aria-valuemax', '100');

    // Nest the elements appropriately
    progress.appendChild(this.progressBar);
    mask.appendChild(progress);

    return mask;
  }
  
  parseSliderId() {
    var id = this.sliders[0].dataset.id;
    
    if(window.location.hash) {
      var hashId = window.location.hash.split('-', 3)[2];
      id = hashId;
    }
    
    return id;
  }

  updateCurrentSlideHash(swiper) {
      
    // First check if it's not the same swiper instance - first load case          
    if (this.parseSliderId() == swiper.el.dataset.id) return;
    
    // Get the active slide
    var activeSlide = swiper.slides[swiper.activeIndex];
    
    // Get the hash from the active slide's data-hash attribute
    var hash = activeSlide.getAttribute('data-hash');
    
    // Manually update the URL hash
    if (hash) {
      window.location.hash = hash;
    }
  }

  setCurrentPageNumber(rotator) {

    var currentSlide = rotator.slides[rotator.activeIndex];
    //console.log(currentSlide.dataset.hash.split('-', 3)[1]);
    
    // Update page number in rotator
    rotator.el.dataset.pageNumber = currentSlide.dataset.hash.split('-', 3)[1];
  }

  async appendNewSlides(rotator) {

    if (this.appendingSlides) {
      //console.log('Already appending! Stopping..');
      return;
    }

    this.appendingSlides = true;

    // Fetch news
    var news = await fetchNews(rotator.el.dataset.urlQuery, Number(rotator.el.dataset.pageSize), Number(rotator.el.dataset.pageNumber) + 1);

    // Create new slides
    var slides = createSlides(rotator.el.dataset.id, Number(rotator.el.dataset.pageSize), Number(rotator.el.dataset.pageNumber) + 1, news.response);
    
    // Append new slides
    rotator.appendSlide(slides);

    //console.log('Slides appended.');

    //console.log(slides);

    var numberOfSlides = rotator.slides.length;

    /*if (numberOfSlides > 20) {
      console.log('1/2 Current number: ' + rotator.slides.length + 'Removing slides...');
      //rotator.removeSlide([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);
      console.log('2/2 Current number: ' + rotator.slides.length + 'Removing slides...');
    }*/

    this.appendingSlides = false;
  }

  async prependNewSlides(rotator) {

    if (Number(rotator.el.dataset.pageNumber) == 0) return false;

    //console.log('Prepending slides.');
    

    // Fetch news
    var news = await fetchNews(rotator.el.dataset.urlQuery, Number(rotator.el.dataset.pageSize), Number(rotator.el.dataset.pageNumber) - 1);

    // Create new slides
    var slides = createSlides(rotator.el.dataset.id, Number(rotator.el.dataset.pageSize), Number(rotator.el.dataset.pageNumber) - 1, news.response.reverse());

    // Prepend new slides
    rotator.prependSlide(slides);

    return true;
  }

  async initBgVideoLoader(avaId, progressBarContainer, progressBar) {
    return new Promise(async (resolve, reject) => {
      var self = this;
      
      this.bgVideoLoader = new BackgroundVideoLoader();
      this.bgPlayerJw = await this.bgVideoLoader.initPlayer(avaId);

      this.bgPlayerContainer = document.createElement("div");
      this.bgPlayerContainer.classList.add('image-container-video');
      this.bgPlayerContainer.appendChild(this.bgVideoLoader.playerElement);

      this.bgPlayerJw.on('ready', () => {
        self.bgPlayerJw.getMute() ? this.sliderContainer.classList.add('muted') : this.sliderContainer.classList.remove('muted');
        /*console.log('ready: ' + self.bgPlayerJw.getState());*/
      });

      this.bgPlayerJw.on('playlistItem', () => {
        self.bgPlayerJw.getPlaylistItemPromise(0).then(() => {
          self.bgPlayerJw.seek(self.currentSeek);
          self.bgPlayerJw.play();
          //console.log('playlistItem: ' + self.bgPlayerJw.getState());
        })
      });

      this.bgPlayerJw.on('firstFrame', () => {
        self.bgPlayerContainer.classList.add('loaded');
        self.bgPlayerContainer.parentElement.classList.add('video-loaded');
        //console.log('firstFrame: ' + self.bgPlayerJw.getState());
      });

      this.bgPlayerJw.on('time', (e) => {
        const percent = (e.position / e.duration) * 100;

        progressBar.style.width = percent + '%';
        progressBar.setAttribute('aria-valuenow', percent);
      });

      progressBarContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        const rect = progressBarContainer.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const percent = clickX / rect.width;
        const duration = self.bgPlayerJw.getDuration();
        self.bgPlayerJw.seek(duration * percent);
      });

      resolve();
    });
  }

  toggleMute() {
    this.bgPlayerJw.setMute();
    
    if (this.bgPlayerJw.getMute() ) {
      window.__bgPlayerMuted = true;
      this.sliderContainer.classList.add('muted');
    } else {
      window.__bgPlayerMuted = false;
      this.sliderContainer.classList.remove('muted');
    }
  }

  async startVideo(el) {

    var currentSlide = el.slides[el.activeIndex];
    var previewId = Number(currentSlide.dataset.previewAvaId);
    var showTypeId = currentSlide.dataset.showTypeId && Number(currentSlide.dataset.showTypeId);

    this.currentSeek = (
      showTypeId &&
      this.showTypeSkipIds instanceof Array &&
      this.showTypeSkipIds.includes(showTypeId)
    ) ? this.skipSeconds : 0;

    //console.log(this.showTypeSkipIds instanceof Array);
    //console.log(showTypeId, this.showTypeSkipIds.includes(showTypeId), seek);

    // this.currentVideoPlay != previewId: Prevent multiple triggering
    if (typeof currentSlide != 'undefined' && previewId && this.currentVideoPlay != previewId) {

      //console.log('AVA ID: ' + previewId + ' (previous: ' + this.currentVideoPlay + ')');

      this.currentVideoPlay = previewId;
      
      // If player doesn't exist, create one
      if (!this.bgVideoLoader) {
        await this.initBgVideoLoader(previewId, this.progressBarContainer, this.progressBar);
      } else {
        // If instance exists, just load new video
        this.bgPlayerContainer.classList.remove('loaded');
        this.bgPlayerContainer.parentElement.classList.remove('video-loaded');
        this.bgVideoLoader.loadVideo(previewId);
      }

      // Append player
      currentSlide.appendChild(this.bgPlayerContainer);

      // Reset progress bar
      this.progressBar.style.width = '0%';
      this.progressBar.setAttribute('aria-valuenow', 0);

      // Append progress bar
      currentSlide.querySelector('.news-slider-card').appendChild(this.progressBarContainer);

      //window.__testBgPlayerJw = this.bgPlayerJw;
      
    } else if(this.currentVideoPlay == previewId ) {
      if(this.bgPlayerJw) {
        this.bgPlayerJw.seek(this.currentSeek);
        this.bgPlayerJw.play();
      }
    } else {
      // If current is not video slide, stop playing previous video slide
      if(this.bgPlayerJw) {
        this.bgPlayerJw.pause();
      }
    }
  }

  initSwiper() {

    var self = this;

    // Init slider
    if (typeof Swiper === 'function') {
      
      if (typeof this.activeSlider.swiper === 'undefined' || !this.activeSlider.swiper) {

        var firstPrependExecute = false;

        this.swiper = new Swiper(this.activeSlider, {
          direction: "vertical",
          slidesPerView: 1,
          mousewheel: true,
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
          },
          hashNavigation: {
            watchState: true
          },
          on: {
            init: function (rotator) {
              self.updateCurrentSlideHash(rotator);
              self.startVideo(rotator);
               
              // Delay prevents unecessary fn() calls when multiple activeIndexChange, reachEnd etc. triggers
              self.startVideoDelayed = createDelayedTrigger(() => self.startVideo(rotator), 500);
              self.appendNewSlidesDelayed = createDelayedTrigger(() => self.appendNewSlides(rotator), 500);
              self.prependNewSlidesDelayed = createDelayedTrigger(() => self.prependNewSlides(rotator), 500);
            },
            activeIndexChange: function (rotator) {
              self.setCurrentPageNumber(rotator);
              self.startVideoDelayed();

              // Execute only on first load. Init is not ok, because the rotator is not yet positioned (hash).
              if (!firstPrependExecute) {
                // Check if has previous page
                if (rotator.activeIndex == 0) self.prependNewSlidesDelayed();
                //console.log('index: ' + rotator.activeIndex);
                firstPrependExecute = true;
              }
            },
            reachEnd: function (rotator) {
              //console.log('--- reached end');

              self.appendNewSlidesDelayed();
            },
            reachBeginning: function (rotator) {
              //console.log('--- reached begin');
              
              self.prependNewSlidesDelayed();
              //var hasReachedTop = self.prependNewSlides(rotator);
              //if (hasReachedTop) document.body.classList.remove('vertical-slider-scrolled');
            },
            sliderFirstMove: function () {
              document.body.classList.add('vertical-slider-scrolled');
            }
          }
        });
      } else {
        this.activeSlider.swiper.enable();
        self.updateCurrentSlideHash(this.activeSlider.swiper)
      }
      
    }
  }
  
  switchSlider(id) {
    
    if (this.activeSlider) {
      this.activeSlider.classList.remove('active');
      if (typeof Swiper === 'function') this.activeSlider.swiper.disable();
    }
    
    this.activeSlider = [...this.sliders].find(slider => slider.dataset.id == id);
    this.activeSlider.classList.add('active');
    
    // Add and remove animation
    this.activeSlider.classList.add('animate');
    setTimeout(() => {
      this.activeSlider.classList.remove('animate');
    }, 300);

    this.initSwiper();
    
    this.switchButtons.forEach( button => {
      button.classList.remove('active');
      
      if (button.dataset.sliderId == id) {
        button.classList.add('active');
        this.sliderSwitcher.scroll({
          top: 0,
          left: button.offsetLeft - 10,
          behavior: 'smooth'
        });
      }
    })
  }
  
  nextSlider() {
    let nextIndex = (Number(this.activeSlider.index) + 1) % this.sliders.length;
    this.switchSlider(this.sliders[nextIndex].dataset.id);
  }
  
  prevSlider() {
    let prevIndex = (Number(this.activeSlider.index) - 1 + this.sliders.length) % this.sliders.length;
    this.switchSlider(this.sliders[prevIndex].dataset.id);
  }
}


function sliderTouchSwitcher(leftSwipeFn, rightSwipeFn, slider) {
  
  slider.sliderContainer.addEventListener('touchstart', handleTouchStart, false);        
  slider.sliderContainer.addEventListener('touchmove', handleTouchMove, false);
  slider.sliderContainer.addEventListener('touchend', handleTouchEnd, false);
  
  var xDown = null;                                                        
  var yDown = null;
  
  var xDiff = null;
  var yDiff = null;

  var disableSliding = false;
  
  function getTouches(evt) {
    return evt.touches ||             // browser API
    evt.originalEvent.touches; // jQuery
  }                                                     
  
  function handleTouchStart(evt) {
    disableSliding = slider.sliderSwitcher.contains(evt.target) ? true : false;
    

    const firstTouch = getTouches(evt)[0];                                      
    xDown = firstTouch.clientX;                                      
    yDown = firstTouch.clientY;
    
    slider.activeSlider.style.willChange = 'transform';
    slider.activeSlider.style.transition = 'none';
  };                                                
  
  function handleTouchMove(evt) {
    if ( ! xDown || ! yDown || disableSliding ) {
      return;
    }
    
    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;
    
    xDiff = xDown - xUp;
    yDiff = yDown - yUp;
    
    if (Math.abs(yDiff) > Math.abs(xDiff) && !disableSliding) {
      disableSliding = true;
      return;
    }
    
    slider.activeSlider.style.transform = `translateX(${-xDiff}px)`;
    
  };
  
  function handleTouchEnd(evt) {

    slider.activeSlider.style.transition = 'transform .2s';
    slider.activeSlider.style.transform = `translateX(0)`;
    
    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
      
      if ( xDiff > 100 ) {
        /* right swipe */ 
        if (typeof rightSwipeFn === 'function') {
          rightSwipeFn();
        }
        
      } else if ( xDiff < -100 ) {
        /* left swipe */
        if (typeof leftSwipeFn === 'function') {
          leftSwipeFn();
        }
      }                       
    }
    
    
    //console.log('xdiff: ' + xDiff + ' ydiff: ' + yDiff);
    
    
    /* reset values */
    xDown = xDiff = null;
    yDown = yDiff = null;
  };
}

async function fetchNews(url, pageSize = 10, pageNumber = 0, noCache) {
  const cacheKey = `${url}&pageSize=${pageSize}&pageNumber=${pageNumber}`;
  const cache = localStorage.getItem(cacheKey);
  const now = Date.now() / 1000;
  const cachedAt = cache ? JSON.parse(cache).cachedAt : 0;
  
  // If cache is 300 sek (5 minutes) old, return cached data
  // const isDev = SKIT_APP_HELPER.isDev()
  // if (cache && now - cachedAt < 300 && !isDev && !noCache) {
  if (cache && now - cachedAt < 300 && !noCache) {
    return JSON.parse(cache).data;
  }
  
  let data;
  let attempts = 0;
  const maxAttempts = 5;
  while (!data && attempts < maxAttempts) {
    try {
      const response = await fetch(url + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber);
      data = await response.json();
    } catch (error) {
      attempts++;
      console.error('Fetch failed, retrying in 3 seconds...', error);
      await new Promise(resolve => setTimeout(resolve, 3000));
    }
  }
  
  localStorage.setItem(cacheKey, JSON.stringify({
    data,
    cachedAt: now
  }));
  
  return data;
}

function createSlides(id, pageSize, pageNumber, data) {

  const appendDev = SKIT_APP_HELPER.isDev() ? '.dev' : '';
  const slides = data.map(response => {
    let thumb = response.lead_image?.image?.orig ?? '';
    if (response.extras?.lead_portait_image) {
      thumb =  "https://img.rtvcdn.si" + response.extras.lead_portait_image;
    }
    thumb = thumb.replace('.jpg', '_fp-tt.jpg');
    
    var keywordList = '';
    keywordList += '<a class="bottom-toolbar__keyword--section" href="javascript:void(0)" onclick="event.stopPropagation();window.history.pushState({}, \'\', \'/' + response.section.url + '\');">#' + response.section.title + '</a>';
    if (response.keywordsList) {
      response.keywordsList.forEach( keyword => {
        keywordList += '<a class="bottom-toolbar__keyword--tags" onclick="event.stopPropagation();" href="/iskanje?q=' + keyword.title + '">#' + keyword.title + '</a>';
      });
    }

    var avaId = null;
    var showTypeId = null;

    // Extract video data
    if (response.extras?.short_video_id) { // 1. Check if main short exists
      avaId = response.extras.short_video_id;
      showTypeId = 0;
    } else if (response.extras?.heading_ava_id) { // 2. Check if heading AVA exists
      avaId = response.extras.heading_ava_id;
      showTypeId = 0;
    } else if (response.recordings[0] && response.recordings[0].mediaType == "video") { // 3. Check if main recording inside article exists
      avaId = response.recordings[0].id;
      showTypeId = response.recordings[0].showTypeId;
    }

    return `
      <div class="swiper-slide"
        data-hash="${pageSize}-${pageNumber}-${id}-${response.id}"
        ${avaId ? `data-preview-ava-id="${avaId}"` : ''}
        ${showTypeId ? `data-show-type-id="${showTypeId}"` : ''}>
        <img data-src="${thumb}" class="swiper-lazy" />
        <div class="swiper-lazy-preloader"></div>
        ${avaId ? `<div class="video-preloader"></div>`: '' }
        <div 
          onclick="SKIT_APP_RTVSLO.showNews('${response.id}')"
          class="news-slider-card">
          <div class="news-slider-card__side-buttons-toolbar">

            <button class="btn side-buttons-toolbar__btn like-remove ${(response.rating.vote_user && response.rating.vote_user > 0) ? '' : 'd-none'}" aria-label="Všečkaj" onclick="event.stopPropagation(); SKIT_APP_RTVSLO.setRatingOnClick(false, ${response.id}, this);">
              <span class="icon-heart" style="color: var(--red); text-shadow: none;" "aria-hidden="true"></span>
              <span class="side-buttons-toolbar__btn__count like-counter ${(response.rating.vote_count && response.rating.vote_count > 0) ? '' : 'd-none'}">${response.rating.vote_count}</span>
            </button>

            <button class="btn side-buttons-toolbar__btn like-add ${(response.rating.vote_user && response.rating.vote_user > 0) ? 'd-none' : ''}" aria-label="Všečkaj" onclick="event.stopPropagation(); SKIT_APP_RTVSLO.setRatingOnClick(true, ${response.id}, this);">
              <span class="icon-heart" "aria-hidden="true"></span>
              <span class="side-buttons-toolbar__btn__count like-counter ${(response.rating.vote_count && response.rating.vote_count > 0) ? '' : 'd-none'}">${response.rating.vote_count}</span>
            </button>

            <button onclick="event.stopPropagation(); if(window.commentWidget) window.commentWidget.openComments(event);" data-newsid="${response.id}" class="rtv-comment-trigger-button btn side-buttons-toolbar__btn" aria-label="Komentiraj"><span class="icon-comment" aria-hidden="true"></span>${(response.comments && response.comments > 0) ? `<span class="side-buttons-toolbar__btn__count">${response.comments}</span>` : ''}</button>
            <button class="btn side-buttons-toolbar__btn d-none" aria-label="Deli"><span class="icon-share" aria-hidden="true"></span></button>
            <button class="btn side-buttons-toolbar__btn d-none" aria-label="Shrani"><span class="icon-bookmark" aria-hidden="true"></span></button>
            <button class="btn side-buttons-toolbar__btn ${avaId ? '' : 'd-none'}" style="background-color: rgba(0,0,0,.5); width: 40px; height: 40px; border-radius: 20px; font-size: 1.5rem;" onclick="event.stopPropagation(); if(window.newsSlider) window.newsSlider.toggleMute();">
              <span class="icon-audio-mute unmute-video-btn" aria-label="Unmute video"></span>
              <span class="icon-audio mute-video-btn" aria-label="Mute video"></span>
            </button>
          </div>
          <h1>${response.extras?.show_audio_icon ? `<span class="icon-audio mr-2" style="position: relative; top: 0.05em;" aria-label="Vsebuje audio posnetek"></span>` : ''}${response.extras?.skit_title ? response.extras.skit_title : response.title}
          </h1>
          <div class="description-toggler hide">
            <div class="description-wrapper">
              <p>${response.lead}</p>
              <div class="bottom-toolbar">
                ${keywordList}
              </div>
            </div>
            <button class="description-toggler-button" aria-label="Prikaži opis" onclick="event.stopPropagation(); this.parentNode.classList.toggle('hide');this.parentNode.parentNode.classList.toggle('expanded');"><span class="icon-arrow2-down"></span></button>
          </div>
        </div>
      </div>`;
  });

  /* Share 
  <a href="javascript:void(0);" onclick="event.stopPropagation();nativeShareCard('${response.title}', '${response.subtitle}', 'https://skit${appendDev}.rtvslo.si${response.link}');" class="bottom-toolbar__icon" title="Deli članek">
    <span class="sr-only">Deli članek</span>
    <span class="icon-share default-icon" aria-hidden="true"></span>
    <span class="icon-share active-icon" aria-hidden="true"></span>
  </a>*/

  return slides;
}


async function createSlider(name, id, color, url, pageSize, pageNumber, customHTMLTitle, noCache) {
  
  const news = await fetchNews(url, pageSize, pageNumber, noCache);

  if (customHTMLTitle) customHTMLTitle = customHTMLTitle.replace(/"/g, '&quot;');
  
  var template = `<div data-slider-name="${name}" data-color="${color}" class="vertical-news-slider swiper-container" data-id="${id}" data-page-size="${pageSize}" data-page-number="${pageNumber}" data-url-query="${url}" ${customHTMLTitle ? 'data-custom-html-title="' + customHTMLTitle + '"' : ''}>
  <div class="swiper-wrapper">`;
    
  var slides = createSlides(id, pageSize, pageNumber, news.response);
  template += slides.join('');

  template += `</div></div>`;
  
  return template;
}


function nativeShareCard(title, text, url) {
  if (!navigator.share) return false;

  navigator.share({
    title: title,
    text: title,
    url: url
  }).then(function () {
    var url_reformated = 'url=' + url.replace(/(^\w+:|^)\/\/[^\/]*/, '');
    if (typeof gemius_event === "function") gemius_event('_action_','', 'event=native_share', url_reformated);
  });
}

function resetVerticalSlider() {

  // Remove rotation notice
  if (window.__checkOrientation) window.removeEventListener('resize', window.__checkOrientation);
  
  // Create slider DOM first
  var sliderContainer = document.querySelector('.vertical-news-slider-container');

  sliderContainer.style.display = 'none';
  sliderContainer.innerHTML = '<div class="slider-switcher"></div>'
  sliderContainer.innerHTML += `<div class="loader" style="display: none;">
    <div class="circles">
      <span class="one"></span>
      <span class="two"></span>
      <span class="three"></span>
    </div>
    <div class="pacman">
      <span class="top"></span>
      <span class="bottom"></span>
      <span class="left"></span>
      <div class="eye"></div>
    </div>
  </div>`;
  sliderContainer.replaceWith(sliderContainer.cloneNode(true)); // Flush all handlers etc.

  document.body.classList.remove('vertical-slider-enabled');
  document.body.classList.remove('vertical-slider-scrolled');
}

async function reloadSlider(id) {

  window.currentSlider = document.querySelector('.vertical-news-slider-container [data-id="' + id + '"]');
  currentSlider.style.display = 'none';

  const sliderName = currentSlider.dataset.sliderName;
  const sliderColor = currentSlider.dataset.color;
  const sliderUrlQuery = currentSlider.dataset.urlQuery;


  document.querySelector('.vertical-news-slider-container .loader').style.display = null;

  const newSliderHTML = await createSlider(sliderName, id, sliderColor, sliderUrlQuery, 10, 0, false, true);

  // Parse HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(newSliderHTML, 'text/html');
  window.newSlider = doc.body.firstChild;
  
  newsSlider.activeSlider.swiper.destroy();
  currentSlider.querySelector('.swiper-wrapper').innerHTML = newSlider.querySelector('.swiper-wrapper').innerHTML;
  currentSlider.dataset.pageNumber = 0;
  newsSlider.initSwiper();
  newsSlider.activeSlider.swiper.slideTo(0, 0);

  currentSlider.style.display = null;
  document.querySelector('.vertical-news-slider-container .loader').style.display = 'none';

}

function addRotationNotice() {
  var rotateModal = document.getElementById('rotateModal');

  if(!rotateModal) return;

  var bsModal = new BSN.Modal(
    rotateModal,
    {
      backdrop: 'static', // we don't want to dismiss Modal when Modal or backdrop is the click event target
      keyboard: false // we don't want to dismiss Modal on pressing [Esc] key
    });

  window.__checkOrientation = () => {
    if (window.innerHeight < window.innerWidth) {
      // Landscape mode detected
      bsModal.show();
    } else {
      // Portrait mode, hide modal
      bsModal.hide();
    }
  }

  // Run function when resized
  window.addEventListener('resize', window.__checkOrientation);
}


async function verticalSliderRender(noCache) {

  // Reset DOM first and prevent weird handlers
  resetVerticalSlider();

  addRotationNotice();

  document.body.classList.add('vertical-slider-enabled');
  
  // Create slider DOM first
  var sliderContainer = document.querySelector('.vertical-news-slider-container');
  sliderContainer.style.display = null;
  window.sliders = [];

  const isDev = typeof SKIT_APP_HELPER == 'object' && SKIT_APP_HELPER.isDev();

  const apiUrl = isDev ? 'api.dev.rtvslo.si' : 'api.rtvslo.si'
  var newsURL = function(sectionID) { return 'https://' + apiUrl + '/news/getSectionLayout/' + sectionID + '?client_id=82013fb3a531d5414f478747c1aca622&filters=rating,with-extras,with-recordings,with-comment-counts&prepare=medium' }

  var hashId = null;
  var hashPageNumber = null;

  if(window.location.hash) {
    hashId = window.location.hash.split('-', 3)[2];
    hashPageNumber = window.location.hash.split('-', 3)[1];
  }

  document.querySelector('.vertical-news-slider-container .loader').style.display = null;
  
  window.sliders[1338] = await createSlider('Zadnje', 1338, 'blue-dark', newsURL(1338), 10, (hashId == 1338 ) ? hashPageNumber : 0, false, noCache);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1338]);
  
  /*window.sliders[1339] = await createSlider('Scena', 1339, 'cyan', newsURL(1339), 10, (hashId == 1339 ) ? hashPageNumber : 0, false);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1339]);
  
  window.sliders[1342] = await createSlider('TV', 1342, 'green', newsURL(1342), 10, (hashId == 1342 ) ? hashPageNumber : 0, false);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1342]);

  window.sliders[1346] = await createSlider('Podcast', 1346, 'red', newsURL(1346), 10, (hashId == 1346 ) ? hashPageNumber : 0, false);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1346]);

  window.sliders[1753] = await createSlider('Prvič', 1753, 'orange', newsURL(1753), 10, (hashId == 1753 ) ? hashPageNumber : 0, false);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1753]);

  window.sliders[1691] = await createSlider('Osvežilna fronta', 1691, 'blue-dark', newsURL(1691), 10, (hashId == 1691 ) ? hashPageNumber : 0, false);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1691]);

  window.sliders[1670] = await createSlider('Slovar spolne vzgoje', 1670, 'cyan', newsURL(1670), 10, (hashId == 1670 ) ? hashPageNumber : 0, false);
  sliderContainer.insertAdjacentHTML('beforeend', window.sliders[1670]);*/


  document.querySelector('.vertical-news-slider-container .loader').style.display = 'none';
  
  
  // Init slider
  if(window.newsSlider?.swiper) window.newsSlider.swiper.destroy(); // Remove global SwiperJS Instance
  if(window.newsSlider?.bgPlayerJw) window.newsSlider.bgPlayerJw.remove(); // Remove global JWPlayer Instance
  let showTypeIds = [15890840, 15890843, 15890841]; // Dokumentarni, filmi, serije
  window.newsSlider = new VerticalNewsSlider(showTypeIds, 180); // Skip 60 seconds
  window.newsSlider.init();

  // Init comments drawer
  if (!window.commentWidget) window.commentWidget = new RTVCommentWidget();
  
  /*rightSwipeFn = () => {
    //console.log('right swipe');
    newsSlider.nextSlider();
  }
  
  leftSwipeFn = () => {
    //console.log('left swipe');
    newsSlider.prevSlider();
  }
  
  sliderTouchSwitcher(leftSwipeFn, rightSwipeFn, newsSlider);*/
}

function mainLogoClickHandler() {
  if (location.hash === '' && window.location.pathname == '/') {
    verticalSliderRender(true);
  }
}

// Delayed trigger to reduce unecessary SwiperJS function calls
// Usage example:
// const delayedTrigger = createDelayedTrigger(() => console.log('Triggered'), 500);
function createDelayedTrigger(callback, milliseconds) {
  let timeout;
  
  return function() {
    if (!timeout) {
      timeout = setTimeout(() => {
        callback();
        clearTimeout(timeout);
        timeout = null;
      }, milliseconds);
    }
  };
}
